import { render, staticRenderFns } from "./InstagramPage.vue?vue&type=template&id=4e027e1a&scoped=true&"
import script from "./InstagramPage.vue?vue&type=script&lang=js&"
export * from "./InstagramPage.vue?vue&type=script&lang=js&"
import style0 from "./InstagramPage.vue?vue&type=style&index=0&id=4e027e1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e027e1a",
  null
  
)

export default component.exports